import React from 'react';
import { useDispatch } from 'react-redux';
import { set as setUiDictionary } from '../../../../redux/actions/ui/dictionary';
import './stylesheet.scss';
import Data from './Data';

const NoAccess = ({ lot, urlTarget }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setUiDictionary('returnToIdlot', lot.id));
  };

  return (
    <div
      id={`lot-${lot.id}`}
      className="myartprice-lots-tile-no-access"
      onClick={() => {
        handleClick();
        window.location = urlTarget;
      }}
    >
      <Data lot={lot} />
    </div>
  );
};

export default NoAccess;
